import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { ToastService } from '../services/toast.service';
import { languageSettings } from '../lenguajeDatatable';
import { UsuarioModalComponent } from '../usuario-modal/usuario-modal.component';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive-bs5';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrl: './usuario.component.css',
})
export class UsuarioComponent implements OnInit {
  @ViewChild(UsuarioModalComponent)
  usuarioModalComponent!: UsuarioModalComponent;
  usuarios: any[] = [];
  dataTable: any;
  faPencil = faPencilAlt;

  constructor(
    private http: HttpClient,
    private apiSrv: ApiService,
    private loadingSrv: LoadingService,
    private toastSrv: ToastService
  ) {}

  ngOnInit(): void {
    this.obtenerUsuarios();
  }

  obtenerUsuarios(): void {
    this.loadingSrv.setLoading(true);
    this.apiSrv.obtenerUsuarios().subscribe(
      (data: any[]) => {
        this.usuarios = data.map((usuario) => {
          usuario.roles = usuario.roles.map((rol: string) =>
            rol.replace('ROLE_', '')
          );
          return usuario;
        });
        this.loadingSrv.setLoading(false);
        this.inicializarTablaUsuarios();
      },
      (error) => {
        this.loadingSrv.setLoading(false);
      }
    );
  }

  inicializarTablaUsuarios(): void {
    const tableBody = this.usuarios.map((usuario) => {
      const roles: string =
        usuario.roles && usuario.roles.length > 0
          ? usuario.roles
              .map((rol: string) => rol.replace('ROLE_', ''))
              .join(', ')
          : 'Sin rol';
      return [
        usuario.id,
        usuario.nombreCompleto,
        usuario.usuario,
        usuario.activo ? 'Activo' : 'Inactivo',
        roles,
        `<button class="btn-editar btn btn-link p-0 d-flex align-items-center"
        id="editarUsuario"
        data-id="${usuario.id}"
        data-nombreCompleto="${usuario.nombreCompleto}"
        data-usuario="${usuario.usuario}"
        data-activo="${usuario.activo}"
        data-roles='${JSON.stringify(usuario.roles)}'>Editar
        <i class="fas fa-pencil-alt ms-1"></i>
      </button>`,
      ];
    });

    this.dataTable = $('#tablaUsuarios').DataTable({
      data: tableBody,
      language: languageSettings,
      columns: [
        { title: 'ID', visible: false },
        { title: 'Nombre usuario' },
        { title: 'Usuario' },
        { title: 'Estado' },
        { title: 'Roles' },
        { title: 'Acciones', orderable: false },
      ],
    });

    $('#tablaUsuarios tbody').on('click', 'button.btn-editar', (event) => {
      const button = $(event.currentTarget);
      const usuario = {
        id: button.attr('data-id'),
        nombreCompleto: button.attr('data-nombreCompleto'),
        usuario: button.attr('data-usuario'),
        activo: button.attr('data-activo') === 'true',
        roles: JSON.parse(button.attr('data-roles') || '[]'),
      };

      this.editarUsuario(usuario);
    });
  }

  recargarTabla(): void {
    if (this.dataTable) {
      this.dataTable.clear().destroy();
    }
    this.obtenerUsuarios();
  }

  abrirModoCreacionUsuario(): void {
    this.eliminarModalBackdrop();
    this.usuarioModalComponent.abrirModoCreacionUsuario();
  }

  eliminarModalBackdrop(): void {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((backdrop) => {
      backdrop.parentNode?.removeChild(backdrop);
    });
  }

  editarUsuario(usuario: any): void {
    this.eliminarModalBackdrop();
    this.usuarioModalComponent.abrirModoEdicionUsuario(usuario);
  }
}
